module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'home': _vm.routeHome
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "c-loading__mask2"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__line"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__line-container",
    class: {
      'c-loading-line--visible': _vm.loadingLine
    }
  }, [_c('h1', {
    staticClass: "c-loading__line-text"
  }, [_vm._v(_vm._s(_vm.loadingText) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "c-loading",
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "c-loading__container"
  }, [_c('h1', {
    staticClass: "c-loading__countdown"
  }, [_vm._v(_vm._s(_vm.counter.count) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "c-loading__container-logo"
  }, [_c('svg', {
    staticClass: "c-loading__logo",
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.3 48"
    }
  }, [_c('title', [_vm._v("Asset 1")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_1-2",
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    staticClass: "c-loading__letter",
    attrs: {
      "stroke": "#000000",
      "stroke-width": "0",
      "stroke-miterlimit": "10",
      "fill": "#000000",
      "fill-opacity": "0",
      "d": "M72,10.94C71.24-.8,56.65,0,56.65,0H45.59V48H56.65s15.61.43,15.61-15.29C72.26,28.65,72.45,19,72,10.94ZM56.85,47.61H47.56A1.6,1.6,0,0,1,46,45.87V1.75S46,.4,47.76.4h9.09S65.74,0,66.13,12.2s.2,18.77.2,19.35C66.33,32.33,66.93,47.61,56.85,47.61Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "c-loading__letter",
    attrs: {
      "stroke": "#000000",
      "stroke-width": "0",
      "stroke-miterlimit": "10",
      "fill": "#000000",
      "fill-opacity": "0",
      "d": "M40.45,0,35.51,7.92,12.12,44.64a6.33,6.33,0,0,1-5.41,3,6.27,6.27,0,0,1-6.33-6.2A6,6,0,0,1,.49,40.3,2,2,0,0,1,1,39.38a1.52,1.52,0,0,1,.31-.22,1.72,1.72,0,0,1,.4-.14,1.37,1.37,0,0,1,.61,0,1.2,1.2,0,0,1,.58.46c.62.7,3.11.5,3.76-.75a2,2,0,0,0,.19-1.07c-.2-1.94-2.37-1.94-2.77-1.94S1.17,35.81.15,40l0,.17h0s0,.09,0,.16a5.77,5.77,0,0,0-.1,1.1A6.65,6.65,0,0,0,6.71,48a6.68,6.68,0,0,0,5.72-3.14l0,0,0-.06h0l12.42-19.5c.78-1.13,1.56-1.13,1.56-1.13H37.52a1,1,0,0,1,1,.93V46.45a1.2,1.2,0,0,1-.94,1.15H32.75s0,.38,0,.39H44.21V0Zm-2,22.9a.91.91,0,0,1-.92.9H26.82s-.79,0-.65-.53l.52-.81c1.47-2.18,8.1-12.69,10.06-15.79l.67-1.06A.59.59,0,0,1,38.48,6Z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "c-head",
    class: {
      'c-head--black': _vm.menuOpen, 'c-head--shop': _vm.sectionShop
    }
  }, [_c('div', {
    staticClass: "c-head__section"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-head__section"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "c-head__logo",
    attrs: {
      "alt": "artful-dodgers-logo",
      "src": "/assets/logoMark.svg"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-head__section"
  }, [_c('div', {
    staticClass: "c-menu__select-wrapper",
    class: {
      'c-menu__select-wrapper--push': _vm.cart.length > 0
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "value": "value",
      "searchable": false,
      "clearable": false,
      "options": _vm.currencies
    },
    model: {
      value: (_vm.selectedCurrency),
      callback: function($$v) {
        _vm.selectedCurrency = $$v
      },
      expression: "selectedCurrency"
    }
  })], 1), _vm._v(" "), (_vm.cart.length > 0) ? _c('a', {
    staticClass: "c-cart__btn",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleCart($event)
      }
    }
  }, [_c('p', {
    staticClass: "c-cart__qtyHeader"
  }, [_vm._v("CART (" + _vm._s(_vm.cart.length) + ")")]), _vm._v(" "), _vm._m(0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "app-container",
    style: ({
      'min-height': _vm.menuHeight,
      'height': _vm.cartHeight
    }),
    attrs: {
      "data-v-bind:class": "{ 'app-container--open': menuOpen }"
    }
  }, [_c('OffcanvasMenu', {
    ref: "menu",
    on: {
      "toggleMenu": _vm.toggleMenu
    }
  }), _vm._v(" "), _c('RingSize', {
    ref: "ringSize"
  }), _vm._v(" "), _c('Cart', {
    ref: "cart",
    attrs: {
      "cart": _vm.cart
    }
  }), _vm._v(" "), (_vm.showCheckout) ? _c('Order', {
    ref: "order",
    class: {
      'c-cart--payment--open': _vm.showCheckout
    },
    attrs: {
      "cart": _vm.cart
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app",
    class: {
      'app--menu-open': _vm.menuAppOpen
    },
    style: ({
      'min-height': _vm.minHeight + 'px'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    },
    on: {
      "beforeLeave": _vm.beforeLeave,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "c-footer",
    class: {
      'c-footer--shop': _vm.sectionShop
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "c-footer__socialBar",
    attrs: {
      "id": "socialBar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-footer__linkSection"
  }, [_c('div', {
    staticClass: "c-footer__links c-footer__links--left"
  }, [_c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/shop"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Shop")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/contact"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/termsandconditions"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Terms & Conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-footer__links c-footer__links--right"
  }, [_c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/shippingandreturns"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Shipping")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/privacypolicy"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-footer__link",
    attrs: {
      "to": "/shippingandreturns"
    }
  }, [_c('p', {
    staticClass: "c-footer__link-text"
  }, [_vm._v("Returns")])])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "c-footer__copyRight"
  }, [_vm._v("© Artful Dodgers Ltd.")]), _vm._v(" "), _c('span', {
    staticClass: "c-footer__byLine"
  }, [_vm._v("Seasoned, sous vide, sauteed and served by Leo Gardiner & Andrei Rotar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "c-cart__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tempShoppingCart2.svg"),
      "alt": "shopping cart icon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer__socialLinks"
  }, [_c('a', {
    staticClass: "c-footer__socialLink",
    attrs: {
      "href": "https://www.facebook.com/Artful-Dodgers-312263936206812",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "c-footer__socialIcon c-footer__socialIcon--fb"
  })]), _vm._v(" "), _c('a', {
    staticClass: "c-footer__socialLink",
    attrs: {
      "href": "https://www.behance.net/artfuldodgers",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "c-footer__socialIcon c-footer__socialIcon--be"
  })]), _vm._v(" "), _c('a', {
    staticClass: "c-footer__socialLink",
    attrs: {
      "href": "https://www.instagram.com/artfuldodgersnz/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "c-footer__socialIcon c-footer__socialIcon--insta"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11bd467d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 389
// module chunks = 0